import Dropdown from 'primevue/dropdown';
import Calendar from 'primevue/calendar';
import Sidebar from 'primevue/sidebar';
import Button from 'primevue/button';
import Chart from './Chart.vue';
export default {
    components: {
        Chart,
        Dropdown,
        Calendar,
        Sidebar,
        Button,
    },
    data() {
        return {
            visibleRight: false,
            date3: null,
        };
    },
};
